import React from 'react'
import { Jobs } from '../index'
import smoothscroll from 'smoothscroll-polyfill'

const Job = ({ filterVacation, setFilterVacation, ourRef, setActiveForm, checkDomenNameState, captchaSiteKey }) => {
  smoothscroll.polyfill()
  return (
    <div>
      <Jobs
        filterVacation={filterVacation}
        setFilterVacation={setFilterVacation}
        ourRef={ourRef}
        setActiveForm={setActiveForm}
        checkDomenNameState={checkDomenNameState}
        captchaSiteKey={captchaSiteKey}
      />
    </div>
  )
}

export default Job
